import { useStoreState } from '@ariakit/react'
import * as React from 'react'

import { useTranslation } from '../../../../../../_providers/TranslationProvider.client'
import { Form } from '../../../../../form/Form'
import { FormInput } from '../../../../../form/FormInput'

import { useWaitlistForm } from './useWaitlistForm'
import { CtaButton } from './WaitlistForm.styles'

export interface WaitlistFormProps {}

export const WaitlistForm: React.FC<WaitlistFormProps> = () => {
  const { waitlist: waitlistCopy, magnolia } = useTranslation()
  const form = useWaitlistForm()

  const isSubmitting = useStoreState(form, state => state.submitting)

  return (
    <Form store={form} noValidate>
      <FormInput
        name='emailAddress'
        type='email'
        placeholder={waitlistCopy.modal.form.email.placeholder}
      />
      <CtaButton submittingLabel={magnolia.general.loading} isSubmitting={isSubmitting}>
        {waitlistCopy.modal.form.cta}
      </CtaButton>
    </Form>
  )
}
